import { createAction, props } from '@ngrx/store';

export const checkEmailAddress = createAction(
  '[Team Management] Check Email Address',
  props<{ email: string }>(),
);

export const onCheckEmailAddressSuccess = createAction(
  '[Team Management] Check Email Address Success',
  props<{ exists: boolean }>(),
);

export const onCheckEmailAddressFailure = createAction(
  '[Team Management] Check Email Address Failure',
  props<{ error: Error }>(),
);

export const TEAM_MANAGEMENT_ACTIONS = {
  checkEmailAddress,
  onCheckEmailAddressSuccess,
  onCheckEmailAddressFailure,
};
